/**
 * Seletor de tema (escuro/claro) das páginas do MCP. Sem JavaScript ele fica escondido; com JavaScript ele aparece,
 * aplica o tema escolhido e o salva no localStorage, que o /assets/theme.js aplica antes da pintura no próximo acesso.
 */
(function () {
    var root = document.documentElement;

    var themeSwitch = document.querySelector("[data-theme-switch]");
    var themeButtons = document.querySelectorAll("[data-theme-set]");
    if (!themeSwitch) {
        return;
    }

    function applyTheme(name) {
        root.setAttribute("data-theme", name);
        themeButtons.forEach(function (button) {
            button.setAttribute("aria-checked", button.getAttribute("data-theme-set") === name ? "true" : "false");
        });
        try {
            localStorage.setItem("lvx-theme", name);
        } catch (e) {
            /**
             * Sem localStorage o tema vale só para esta página.
             */
        }
    }

    themeSwitch.hidden = false;
    themeButtons.forEach(function (button) {
        button.addEventListener("click", function () {
            applyTheme(button.getAttribute("data-theme-set"));
        });
    });
    applyTheme(root.getAttribute("data-theme") || "escuro");
})();
